import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { APP_NAME } from '../config.ts';

/** Estructura de las pantallas públicas: la tarjeta centrada y nada más. */
export function AuthLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-dvh flex-col justify-center p-4">
      <div className="mx-auto mb-5 w-full max-w-sm text-center">
        <h1 className="text-2xl font-extrabold">{APP_NAME}</h1>
        <p className="mt-1 text-sm text-tenue">{t('app.tagline')}</p>
      </div>
      <div className="tarjeta mx-auto w-full max-w-sm">{children}</div>
      <p className="mx-auto mt-4 max-w-sm text-center text-xs text-tenue">{t('app.noMoney')}</p>
    </div>
  );
}
